import { OnEventDispatcher } from "./core/on-event-dispatcher";
import { Application } from "./main";
import { HtmlPartials } from "../../shared/htmlpartials";
import { GADataLayer } from "./io/gadatalayer";
import { loadJson } from "./core/loadjson";

export class ArticleView extends OnEventDispatcher {

    elm: JQuery<HTMLElement>;

    inner: JQuery<HTMLElement>;
    
    constructor(container:JQuery<HTMLElement>, path:string) {
        super();

        Application.showLoader();

        //console.log("Open article view with data ", data);
        (async () => {
            let data:any = null;

            console.log("contentslug: " + Application.getDataSlug());
            console.log("path: " + path);
            if(Application.getDataSlug()!=path) {
                console.log("Loading data...");
                Application.setDataSlug(path);
                container.html("");
                data = await loadJson(path+"/json");
                this.elm = $(HtmlPartials.getVaxiArticle(data)).appendTo(container);
                Application.setTitle(data.title);
            } else {
                console.log("Data already set...");
                this.elm = container.find("> .article-view");
            }
    
            $(".content")[0].scrollTo(0,0);

            Application.hideLoader();
    
            //console.log(this.elm);
    
            container.find("a").each((_index:number, helm:HTMLElement) => {
                let elm = $(helm);
                let href:string = elm.attr("href");
                let isInternal:boolean = ((href.indexOf("/")==0&&href.indexOf("//")!=0&&href.indexOf("http")!=0)) || (href.indexOf("#")==0||href.indexOf("javascript:")==0);
                if(!isInternal) {
                    elm.attr("target", "_blank");
                }
                elm.on("click", (e:any) => {
                    GADataLayer.link_click(href, window.location.pathname, elm.attr("id"), elm.attr("class"));
                    if(isInternal && href.indexOf("#")!=0 && href.indexOf("javascript:")!=0) {
                        e.preventDefault();
                        e.stopPropagation();
                        Application.stateManager.setPath(href);
                        return false;
                    }
                });
            });
        })();
        
    }

}